import React, {useEffect, useState} from 'react';
import {Button, Card, Empty, Form, Input, InputNumber, message, Modal, Select, Spin} from "antd";
import Swal from "sweetalert2";

function BulkQRReset(props) {

    const {getFieldDecorator, validateFields} = props.form;
    const {
        pvId,
        pvData,
        showQRResetView,
        toggleQRResetView,
        loading,
        processQRReversal,
        qrResetProcessJob
    } = props;

    const [job, setJob] = useState(null)
    const [api, setApi] = useState(process.env.REACT_APP_ENVIRONMENT === `development`
        ? `http://localhost:3002/v2/`
        : process.env.REACT_APP_ENVIRONMENT === `production`
            ? `https://api.theassetpro.com/v2/`
            : `https://api.quonitrix.com/v2/`,)

    useEffect(() => {
        setJob(null)
    }, []);


    useEffect(() => {
        // console.log(bulkProcessJob)
        if (qrResetProcessJob) {
            setJob(qrResetProcessJob && qrResetProcessJob.id)
        }
    }, [qrResetProcessJob]);


    useEffect(() => {
        if (job) {
            // console.log(`${api}pre-verification-approval/sse?job=${job}`)
            const eventSource = new EventSource(`${api}common/sse-job-status?job=${job}`);

            eventSource.onmessage = (event) => {
                const data = JSON.parse(event.data);
                // console.log('Received message from server:', data);
                if (data && data.state) {
                    message.loading({content: 'Loading...', key: 'updatable'});
                }
                if (data && data.state && data.state === 'completed') {
                    console.log(data)
                    message.success({content: 'Completed', key: 'updatable', duration: 2});
                    eventSource.close();
                    setJob(null);
                    if (data.result) {
                        Swal.fire({
                            title: `QR Reset Log`,
                            html: `<pre style="max-height: 300px; overflow-y: scroll; font-size: small">${JSON.stringify(data.result, null, 1)}</pre>`,
                            confirmButtonText: 'Close'
                        });
                    }
                }
            };

            eventSource.onerror = (error) => {
                console.error('SSE error:', error);
                eventSource.close();
                setJob(null);
            };

            return () => {
                eventSource.close();
                setJob(null);
            };
        }
    }, [job]);

    const handleSubmit = (e) => {
        e.preventDefault();
        props.form.validateFields((err, values) => {
            if (err) {
                return console.log(err);
            }
            // console.log(values);
            processQRReversal({pvId});

            setTimeout(() => {
                toggleQRResetView();
            }, 100)
        });
    }

    return (
        <div>
            <Modal
                title="PV QR Reset"
                visible={showQRResetView}
                onCancel={toggleQRResetView}
                footer={null}>

                <Spin spinning={loading}>
                        <Card className={`gx-card-metrics`}
                              title={`Confirmation for QR reset for ${pvData.assetDetails && pvData.assetDetails.length} assets in ${pvData.pvNo} for Bulk Approval`}>
                            <Form onSubmit={handleSubmit} layout="vertical">
                                <Form.Item>
                                    <p>Resetting QRS to the original stage, i.e. till the pre-verification stage will be a irreversible process. Do you want to continue ?</p>
                                </Form.Item>
                                <Form.Item>
                                    <Button type="primary" htmlType="submit" className="gx-mb-0" disabled={!!job}>
                                        {`Yes, Reset QRs in ${pvData.assetDetails && pvData.assetDetails.length} asset/s under ${pvData.pvNo}`}
                                    </Button>
                                </Form.Item>

                            </Form>
                        </Card>


                </Spin>
            </Modal>

        </div>
    );
}

const BulkQRReversalForm = Form.create({name: 'bulk_approval_form'})(BulkQRReset);

export default BulkQRReversalForm;
